function $1(props) {
    return (
        <ul>

<li>
  <a href="https://doi.org/10.3390/vaccines13050437" target="_blank" rel="noopener noreferrer">Vaccination schedules recommended by the Centers for Disease Control and Prevention: From human-readable to machine-processable</a>
  <p>Jing X, Min H, Gong Y, Ernst MA*, Weaver A*, Crozier C*, Robinson D, Sittig DF, Biondich P, Orlioglu S*, Boobalan AS*, Abanyie K*, Boyce RD, Wright A, Nøhr C, Law TD, Faxvaag A, Rennert L, Gimbel RW</p>
  <p>Vaccines. 13(5), 437. PMID: 40432049; PMCID: PMC12116024</p>
</li>

<li>
  <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC12150700/" target="_blank" rel="noopener noreferrer">Reusable Generic Clinical Decision Support System Module for Immunization Recommendations in Resource-Constraint Settings</a>
  <p>Orlioglu S*, Boobalan AS*, Abanyie K*, Boyce RD, Min H, Gong Y, Sittig DF, Biondich P, Wright A, Nøhr C, Law T, Robinson D, Faxvaag A, Hubig NC, Gimbel R, Rennert L, Jing X</p>
  <p>AMIA Summit 2025. Mar 10–13, 2025. Pittsburgh, Pennsylvania. eCollection. 395–404. PMID: 40502239; PMCID: PMC12150700</p>
</li>

<li>
  <a href="https://doi.org/10.3233/SHTI240660" target="_blank" rel="noopener noreferrer">Active learning pipeline to identify candidate terms for a CDSS ontology</a>
  <p>Jing X, Goli R*, Komatineni K*, Alluri S*, Hubig N, Min H, Gong Y, Sittig DF, Biondich P, Robinson D, Nøhr C, Faxvaag A, Wright A, Law T, Rennert L, Gimbel R</p>
  <p>Stud Health Technol Inform. 2024 Aug 22;316:1338–1342. PMID: 39176629; PMCID: PMC12149559</p>
</li>

 <li>
  <a href="https://medrxiv.org/cgi/content/short/2025.04.15.25325868v3" target="_blank" rel="noopener noreferrer"> Active learning pipeline to automatically identify candidate terms for a CDSS ontology—measures, experiments, and performance </a>
  <p>Alluri S*, Komatineni K*, Goli R*, Boyce RD, Hubig N, Min H, Gong Y, Sittig DF, Robinson D, Biondich P, Wright A, Nøhr C, Law T, Faxvaag A, Gimbel R, Rennert L, Jing X</p>
  <p>MedRxiv, Under Review</p>
</li>

<li>
  <a href="https://doi.org/10.3233/SHTI240638" target="_blank" rel="noopener noreferrer">Challenges and Opportunities of Artificial Intelligence in CDSS and Patient Safety</a>
  <p>Gong Y, Min H, Jing X, Yu P</p>
  <p>Stud Health Technol Inform. 2024 Aug 22;316:1250–1254. PMID: 39176608; PMCID: PMC12145886</p>
</li>

<li>
  <a href="assets/PDFs/Akash_Summit_2024.pdf" target="_blank">Developing a Reusable Clinical Decision Support System Module for Immunization Recommendations: A Case Study with OpenEMR and OpenMRS.</a>
  <p>Boobalan AS*, Orlioglu S*, Boyce RD, Min H, Gong Y, Sittig DF, Biondich P, Wright A, Nøhr C, Law T, Robinson D, Faxvaag A, Hubig NC, Gimbel R, Rennert L, Jing X</p>
  <p>AMIA Summit 2024, page 799–800. Mar 18–21, Boston</p>
</li>

<li>
  <a href="assets/PDFs/Keerthana_Summit_2024.pdf" target="_blank">Fine-tuning a Hierarchical Attention Based BiLSTM-CRF Model Using Minimal Labeled Data.</a>
  <p>Komatineni K*, Goli R*, Alluri S*, Hubig NC, Min H, Gong Y, Sittig DF, Robinson D, Biondich P, Wright A, Nøhr C, Law T, Faxvaag A, Gimbel R, Rennert L, Jing X</p>
  <p>AMIA Summit 2024, page 760–761. Mar 18–21, Boston</p>
</li>

<li>
  <a href="">Literature Analysis on Ontologies Applied in Clinical Decision Support Systems (https://ebooks.iospress.nl/doi/10.3233/SHTI231188)</a>
  <p>Jing X, Min H, Gong Y, Biondich P, Robinson D, Law T, Nohr CG, Faxvaag A, Rennert L, Hubig N, Gimbel R</p>
  <p>Studies in Health Technology and Informatics, 2024, 310: 1347-1348. PMID: 38270037; PMCID: PMC10964188; DOI: 10.3233/SHTI231188</p>
</li>

<li>
  <a href="https://doi.org/10.36922/jci.4496" target="_blank" rel="noopener noreferrer">Perspectives on Enhancing Clinical Informatics Education in the Artificial Intelligence Era</a>
  <p>Min H, Jing X, Gong Y, Yu P</p>
  <p>Journal of Clinical Informatics. JCI 2024, 1(1), 4496. PMID: 40051784; PMCID: PMC11884742</p>
</li>

<li>
  <a href="https://doi.org/10.1101/2023.01.26.23285060" target="_blank" rel="noopener noreferrer">
    Keyphrase Identification Using Minimal Labeled Data with Hierarchical Context and Transfer Learning.
  </a>
  <p>Goli R*, Hubig N, Min H, Gong Y, Sittig DF, Rennert L, Robinson D, Biondich P, Wright A, Nøhr C, Law T, Faxvaag A, Weaver A*, Gimbel R, Jing X</p>
  <p>BMC Med Inform Decis Mak. Under review. MedRxiv Preprint, 2023. PMID: 37292830; PMCID: PMC10246160; DOI: 10.1101/2023.01.26.23285060</p>
</li>

<li>
<a href="http://dx.doi.org/10.2196/43053" target="_blank" rel="noopener noreferrer">Ontologies Applied in Clinical Decision Support System Rules: Systematic Review.</a>
<p>Jing X, Min H, Gong Y, Biondich P, Robinson D, Law T, Nøhr C, Faxvaag A, Rennert L, Hubig N, Gimbel R</p>
<p>JMIR Med Inform, 2023. PMID: 36534739; PMCID: 9896360</p>
</li>

<li>
  <p>Using Semantic Web Technology to leverage interoperable clinical decision support system rules: a pathway to interoperable patient records.</p>
  <p>Jing X, Cimino JJ, Sittig DF, Min H, Gong Y, Boyce RD, Robinson D, Biondich P, Wright A, Nøhr CG, Law T, Faxvaag A, Hubig N, Goli R, Nedunchezhiyan K, Boobalan AS, Orlioglu S, Crozier C, Rennert L, Gimbel R</p>
  <p>BMC Proceedings, 2023, 17(Suppl 19):O13</p>
</li>

<li>
  <a href="assets/PDFs/Rohan_AMIA2022_2Pages.pdf" target="_blank">Keyphrase identification with limited labeled dataset using deep active learning and domain adaptation</a>
  <p>Goli R*, Hubig N, Min H, Gong Y, Sittig DF, Robinson D, Biondich P, Wright A, Nøhr C, Law T, Faxvaag A, Gimbel R, Rennert L, Jing X</p>
  <p>AMIA 2022, Nov 5-9, 2022, Washington DC</p>
</li>

<li>
  <p>Keyphrase identification with limited labeled dataset using deep active learning and domain adaptation</p>
  <p>Goli R*, Hubig N, Renert L, Gimbel R, Jing X</p>
  <p>The 7th Annual Clemson Research Symposium, Clemson, SC, 2022-05-10</p>
</li>

<li>
  <a href="https://doi.org/10.1055/a-1862-0421" target="_blank" rel="noopener noreferrer">
    A systematic approach to configuring MetaMap for optimal performance.
  </a>
  <p>Jing X, Indani A*, Hubig N, Min H, Gong Y, Cimino JJ, Sittig DF, Rennert L, Robinson D, Biondich P, Wright A, Nøhr C, Law T, Faxvaag A, Gimbel R</p>
  <p>Methods Inf Med, 2022. PMID: 35613942; PMCID: PMC9788913; DOI: 10.1055/a-1862-0421</p>
</li>

<li>
  <p>A clinical decision support system (CDSS) ontology to facilitate portable vaccination CDSS rules: preliminary results.</p>
  <p>Jing X, Min H, Gong Y, Cimino JJ, Robinson D, Sittig D, Biondich P, Wright A, Nøhr C, Law T, Faxvaag A, Indani A*, Hubig N, Gimbel R, Rennert L</p>
  <p>AMIA Annu Symp Proc. 2022 Feb 21;2021. Page 1695.</p>
</li>

       
    </ul>
    );
}

export default $1;
